import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';

const CRM = lazy(() => import('@/pages/CRM'));

export const Route = createFileRoute('/crm/')({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <CRM />
    </Suspense>
  ),
});
